/* eslint-disable no-useless-concat */
import axios from "axios";
import Config from "../../config";
import error1 from "../../assets/error.svg";
import { callNotification, errorCode, getUTCOffset } from "../constants";
import { handleApiError, handleAxiosError } from "../utils/errorHandler";
import { setWidgetAIGeneratedInsights } from "./dashboard/Tab1";
import { notification } from "antd";
import { setPPTDashboardData } from "./ApiCall/apiCall";
export const setPptDownload = (value, authParams) => {
  return async (dispatch) => {
    let url = `${Config.config1.api_link}/ppt-report/generate-ppt`;
    await axios
      .post(url, { ...value, utcoffset: getUTCOffset() })
      .then((response) => {
        let timer = null;
        dispatch({
          type: "SET_PPT_RESPONSE",
          payload: response,
        });
        dispatch(setPPTGenerateStatus(false));

        if (response?.data?.status === "successful") {
          const link = document.createElement("a");
          link.href = response?.data?.ppt_url;
          link.download = "SmartInsights screenshot";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          callNotification("PPT report downloaded successfully", "success");
          dispatch(setPPTModalOpen(false));
          timer = setTimeout(() => {
            let url = new URL(window.location.href);
            if (
              Config?.config1?.app_id === "1" ||
              Config?.config1?.app_id === "2"
            ) {
            } else {
              window.close(url);
            }
          }, [5000]);
        } else if (response?.data?.status === "error") {
          notification.open({
            className: "notification_body notification_body_bg",
            key: 1,
            placement: "bottomLeft",
            icon: <img src={error1} alt={"error"} />,
            duration: 0,
            message: (
              <span className="notification_message">
                PPT generation failed!
              </span>
            ),
          });
          dispatch(setPPTModalOpen(false));
          // Also handle with standard error handler
          handleApiError(response, dispatch, { suppressNotification: true });
        }
        return () => {
          clearTimeout(timer);
        };
      })
      .catch((error) => {
        notification.open({
          className: "notification_body notification_body_bg",
          key: 1,
          placement: "bottomLeft",
          icon: <img src={error1} alt={"error"} />,
          duration: 0,
          message: (
            <span className="notification_message">PPT generation failed!</span>
          ),
        });
        dispatch(setPPTModalOpen(false));
        dispatch(setPPTGenerateStatus(false));
        // Also handle with standard error handler for other error types
        handleAxiosError(error, dispatch, { suppressNotification: true });
      });
  };
};

export const setPptImageUrl = (value, data, list) => {
  return async (dispatch) => {
    if (value) {
      let body = {
        image_base64: value,
        utcoffset: getUTCOffset(),
      };

      let url = `${Config.config1.api_link}/ppt-report/upload-chart`;
      axios
        .post(url, body)
        .then((response) => {
          dispatch({
            type: "SET_PPT_IMAGE_URL",
            payload: response,
          });

          if (response?.data?.status === "successful") {
            let obj = { ...data };
            obj.url = response?.data?.image_url;
            dispatch(setImageList(obj, list));
          } else if (response?.data?.status === "error") {
            handleApiError(response, dispatch);
          }
        })
        .catch((error) => {
          handleAxiosError(error, dispatch);
        });
    } else {
      let obj = { ...data };
      obj.url = "No data found";
      dispatch(setImageList(obj, list));
    }
  };
};
export const setPptTemplateData = (authParams, obj) => {
  return async (dispatch) => {
    if (authParams?.category_id) {
      let body = {
        category_id: authParams?.category_id,
        category_name: authParams?.category_name,
        ai_insights_checked: obj,
        utcoffset: getUTCOffset(),
      };

      let url = `${Config.config1.api_link}/ppt-report/preview-details`;
      axios
        .post(url, body)
        .then((response) => {
          dispatch({
            type: "SET_PPT_TEMPLATE_DATA",
            payload: response?.data,
          });

          if (response?.data?.status === "successful") {
          } else if (response?.data?.status === "error") {
            handleApiError(response, dispatch);
          }
        })
        .catch((error) => {
          handleAxiosError(error, dispatch);
        });
    } else {
      dispatch({
        type: "SET_PPT_TEMPLATE_DATA",
        payload: null,
      });
    }
  };
};

export const setImageList = (url, list, no_url) => {
  let arr = [];

  if (url) {
    arr = global.image_list ? [...global.image_list] : [...list];
    arr.push(url);
    global.image_list = arr;
  }

  return (dispatch) => {
    dispatch({ type: "SET_IMAGE_LIST", payload: arr });
  };
};
export const setPptId = (id) => {
  return (dispatch) => {
    dispatch({ type: "SET_PPT_ID", payload: id });
  };
};
export const setPPTModalOpen = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PPT_MODAL_OPEN", payload: value });
  };
};
export const setPPTGenerateStatus = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PPT_GENERATE_STATUS", payload: value });
  };
};
export const setAIInsightsLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_AI_INSIGHT_LOADER", payload: value });
  };
};
export const setPptLoaderOffset = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PPT_LOADER_OFFSET", payload: value });
  };
};
export const setCallPpt = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_CALL_PPT", payload: value });
  };
};
export const setdownload = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PPT_DOWNLOAD", payload: value });
  };
};
export const setAIGeneratedInsights = (value, widget, authParams) => {
  return async (dispatch) => {
    let sections =
      widget?.panes && widget?.panes[widget?.pane_index]?.sections
        ? widget?.panes[widget?.pane_index]?.sections
        : widget?.panes && widget?.panes[widget?.pane_index]?.section;
    if (value) {
      let body = {
        ...value,
        graphData:
          sections[widget?.section_index !== null ? widget?.section_index : 0]
            ?.widgets[widget?.widget_index]?.graphData,
        widget_id: widget?.widget_id,
        dashboard_name: widget?.dashboard_name,
        section_name: widget?.section_name,
        prompt_text: widget?.prompt_text,
        utcoffset: getUTCOffset(),
      };
      dispatch(
        setAIInsightsLoader({
          s_i:
            widget?.section_index !== null ? widget?.section_index : undefined,
          w_i: widget?.widget_index,
          value: true,
        })
      );

      let url = `${Config.config1.api_link}/template/get-ai-insights`;

      // Custom error handlers for AI insights API with specific business logic
      const customErrorHandlers = {
        201: (errorCodeValue, errorMessage, response, dispatch) => {
          // Special handling for error code 201 - show response reason instead of notification
          dispatch(
            setWidgetAIGeneratedInsights(
              response?.data?.reason,
              widget?.pane_index,
              widget?.panes,
              widget?.section_index,
              widget?.widget_index
            )
          );
          dispatch(setAIInsightsLoader({ s_i: null, w_i: null, value: false }));
        },
        default: (errorCodeValue, errorMessage, response, dispatch) => {
          // Default error handling for other error codes including 21
          callNotification(errorMessage, "error");
          dispatch(setAIInsightsLoader({ s_i: null, w_i: null, value: false }));
        },
      };

      axios
        .post(url, body)
        .then((response) => {
          dispatch({
            type: "SET_AI_GENERATED_INSIGHTS",
            payload: response,
          });

          if (response?.data?.status === "successful") {
            if (response?.data?.result[0]?.ai_generated_insights) {
              dispatch(
                setWidgetAIGeneratedInsights(
                  response?.data?.result,
                  widget?.pane_index,
                  widget?.panes,
                  widget?.section_index,
                  widget?.widget_index,
                  widget?.prompt_text
                )
              );
            } else {
              dispatch(
                setWidgetAIGeneratedInsights(
                  "AI generated insights not found",
                  widget?.pane_index,
                  widget?.panes,
                  widget?.section_index,
                  widget?.widget_index
                )
              );
            }
            dispatch(
              setAIInsightsLoader({ s_i: null, w_i: null, value: false })
            );
          } else if (response?.data?.status === "error") {
            handleApiError(response, dispatch, { customErrorHandlers });
          }
        })
        .catch((error) => {
          dispatch(setAIInsightsLoader({ s_i: null, w_i: null, value: false }));
          handleAxiosError(error, dispatch, { customErrorHandlers });
        });
    } else {
      dispatch({
        type: "SET_AI_GENERATED_INSIGHTS",
        payload: null,
      });
    }
  };
};
export const setMapOnReady = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_MAP_RENDERED", payload: value });
  };
};
export const setAIInsightStatus = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_AI_INSIGHTS_STATUS", payload: value });
  };
};

export const setDeeperAIInsightLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEPER_AI_INSIGHTS_LOADER", payload: value });
  };
};

const setAIInsightsCondition = (widget, status, response) => {
  if (status === "successful") {
    if (
      widget?.insight_type === "peak" &&
      widget?.insight_type_lable === "peak"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.peak.data =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      aiUpadteData.peak.prompt = response?.data?.prompt;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-1" &&
      widget?.insight_type_lable === "peak"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.peak.level_1 =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-2" &&
      widget?.insight_type_lable === "peak"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.peak.level_2 =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      return aiUpadteData;
    } else if (
      widget?.insight_type === "valley" &&
      widget?.insight_type_lable === "valley"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.valley.data =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-1" &&
      widget?.insight_type_lable === "valley"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.valley.level_1 =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-2" &&
      widget?.insight_type_lable === "valley"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.valley.level_2 =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-1" &&
      widget?.insight_type_lable === "TopKeyInsights"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.top_key.level_1 =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      aiUpadteData.top_key.level_1_prompt = response?.data?.prompt;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-2" &&
      widget?.insight_type_lable === "TopKeyInsights"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.top_key.level_2 =
        response?.data?.result?.[0]?.ai_generated_insights?.[0];
      aiUpadteData.top_key.level_2_prompt = response?.data?.prompt;
      return aiUpadteData;
    }
  } else if (status === "error") {
    if (
      widget?.insight_type === "peak" &&
      widget?.insight_type_lable === "peak"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.peak.data = response?.data;
      aiUpadteData.peak.prompt = response?.data?.prompt;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-1" &&
      widget?.insight_type_lable === "peak"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.peak.level_1 = response?.data;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-2" &&
      widget?.insight_type_lable === "peak"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.peak.level_2 = response?.data;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "valley" &&
      widget?.insight_type_lable === "valley"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.valley.data = response?.data;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-1" &&
      widget?.insight_type_lable === "valley"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.valley.level_1 = response?.data;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-2" &&
      widget?.insight_type_lable === "valley"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.valley.level_2 = response?.data;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-1" &&
      widget?.insight_type_lable === "TopKeyInsights"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.top_key.level_1 = response?.data;
      aiUpadteData.top_key.level_1_prompt = response?.data?.prompt;
      return aiUpadteData;
    } else if (
      widget?.insight_type === "level-2" &&
      widget?.insight_type_lable === "TopKeyInsights"
    ) {
      let aiUpadteData = { ...widget?.aiDeeperInsightsStatus };
      aiUpadteData.top_key.level_2 = response?.data;
      aiUpadteData.top_key.level_2_prompt = response?.data?.prompt;
      return aiUpadteData;
    }
  }
};

export const setDeeperAIInsightStatus = (value, widget, authParams) => {
  return async (dispatch) => {
    if (value) {
      let body = {
        ...value,
        graphData: widget?.graphData,
        widget_id: widget?.widget_id,
        dashboard_name: widget?.dashboard_name,
        section_name: widget?.section_name,
        prompt_text: widget?.prompt_text,
        insight_type: widget?.insight_type,
        utcoffset: getUTCOffset(),
      };
      dispatch(
        setDeeperAIInsightLoader({
          insight_type: widget?.insight_type,
          loader: true,
        })
      );
      let url = `${Config.config1.api_link}/template/get-deeper-ai-insights`;

      // Custom error handlers for deeper AI insights API with specific business logic
      const customErrorHandlers = {
        201: (errorCodeValue, errorMessage, response, dispatch) => {
          // Special handling for error code 201 - handle with setAIInsightsCondition
          dispatch(
            setDeeperAIInsightLoader({
              insight_type: widget?.insight_type,
              loader: false,
            })
          );
          let AiData = setAIInsightsCondition(
            widget,
            response?.data?.status,
            response
          );
          dispatch({
            type: "SET_DEEPER_AI_INSIGHTS_STATUS",
            payload: AiData,
          });
        },
        default: (errorCodeValue, errorMessage, response, dispatch) => {
          // Default error handling for other error codes including 21
          callNotification(errorMessage, "error");
          dispatch(
            setDeeperAIInsightLoader({
              insight_type: widget?.insight_type,
              loader: false,
            })
          );
        },
      };

      axios
        .post(url, body)
        .then((response) => {
          if (response?.data?.status === "successful") {
            let AiData = setAIInsightsCondition(
              widget,
              response?.data?.status,
              response
            );
            dispatch({
              type: "SET_DEEPER_AI_INSIGHTS_STATUS",
              payload: AiData,
            });
            dispatch(
              setDeeperAIInsightLoader({
                insight_type: widget?.insight_type,
                loader: false,
              })
            );
          } else if (response?.data?.status === "error") {
            handleApiError(response, dispatch, { customErrorHandlers });
          }
        })
        .catch((error) => {
          dispatch(
            setDeeperAIInsightLoader({
              insight_type: widget?.insight_type,
              loader: false,
            })
          );
          dispatch({
            type: "SET_DEEPER_AI_INSIGHTS_STATUS",
            payload: {
              peak: { data: null, level_1: null, level_2: null },
              valley: { data: null, level_1: null, level_2: null },
              top_key: { level_1: null, level_2: null },
            },
          });
          handleAxiosError(error, dispatch, { customErrorHandlers });
        });
    } else {
      dispatch(
        setDeeperAIInsightLoader({
          insight_type: widget?.insight_type,
          loader: false,
        })
      );
      dispatch({
        type: "SET_DEEPER_AI_INSIGHTS_STATUS",
        payload: {
          peak: { data: null, level_1: null, level_2: null },
          valley: { data: null, level_1: null, level_2: null },
          top_key: { level_1: null, level_2: null },
        },
      });
    }
  };
};

export const setFetchPptMetadata = (schedule_id, payloadOption) => {
  let errorMessage;
  return async (dispatch) => {
    let url = `${Config.config1.api_link}/template/fetch-ppt-metadata`;
    let body = {
      schedule_id: schedule_id,
      ptoken: payloadOption?.auth_params?.ptoken,
    };

    await axios
      .post(url, body)
      .then((response) => {
        let timer = null;

        if (response?.status === 200) {
          if (response?.data?.status === "successful") {
            dispatch(setPptId(null));
            if (payloadOption) {
              let sections = payloadOption?.panes[payloadOption?.pane_index]
                ?.sections
                ? payloadOption?.panes[payloadOption?.pane_index]?.sections
                : payloadOption?.panes[payloadOption?.pane_index]?.section
                ? payloadOption?.panes[payloadOption?.pane_index]?.section
                : [{}];

              response?.data?.result?.sections &&
                response?.data?.result?.sections?.forEach((section, i) => {
                  if (
                    response?.data?.result?.template_metadata?.contains_sections
                  ) {
                    sections[i].widgets = section?.widgets;
                  } else {
                    sections[0] = section;
                  }

                  section?.widgets?.forEach((widget, j) => {
                    if (sections?.[i] && sections?.[i]?.widgets?.[j]) {
                      sections[i].widgets[j].insights = null;
                      sections[i].widgets[j].open = false;
                      sections[i].widgets[j].graphData = widget?.graphData
                        ? widget?.graphData
                        : "No data found";
                    } else if (section?.[0] && sections?.[0]?.widgets?.[j]) {
                      sections[0].widgets[j].insights = null;
                      sections[0].widgets[j].open = false;
                      sections[0].widgets[j].graphData = widget?.graphData
                        ? widget?.graphData
                        : "No data found";
                    }
                  });
                });

              let updatePanes = [...payloadOption?.panes];
              if (payloadOption?.panes[payloadOption?.pane_index]?.sections) {
                updatePanes[payloadOption?.pane_index].sections = sections;
              } else {
                updatePanes[payloadOption?.pane_index].section = sections;
              }

              dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });

              timer = setTimeout(() => {
                dispatch(setPPTDashboardData(true));
              }, 2000);
            }
            // else {
            //   dispatch(setPdfData(response?.data?.result));
            // }
          } else if (response?.data?.status === "error") {
            errorCode?.map((el, i) => {
              return el.key === response?.data?.error_code
                ? (errorMessage = el.value)
                : null;
            });
            if (payloadOption) {
              notification.open({
                className: "notification_body notification_body_bg",
                key: 1,
                placement: "bottomLeft",
                icon: <img src={error1} alt={"error"} />,
                duration: 0,
                message: (
                  <span className="notification_message">
                    PPT generation failed. Please try again!
                  </span>
                ),
              });
              dispatch(setPPTGenerateStatus(false));
              dispatch(setPPTModalOpen(false));
            }
          } else if (response?.data?.status === "waiting") {
            //call this api again
          }
        }
      })
      .catch((error) => {
        notification.open({
          className: "notification_body notification_body_bg",
          key: 1,
          placement: "bottomLeft",
          icon: <img src={error1} alt={"error"} />,
          duration: 0,
          message: (
            <span className="notification_message">PPT generation failed!</span>
          ),
        });
        dispatch(setPPTModalOpen(false));
        dispatch(setPPTGenerateStatus(false));
      });
  };
};
